export const salutationList = [
  {
    id: '01',
    name: 'Mr.'
  },
  {
    id: '02',
    name: 'Miss.'
  },
  {
    id: '03',
    name: 'Mrs.'
  },
  {
    id: '03',
    name: 'Master'
  }
]

export const statusList = [
  {
    id: '01',
    name: 'ACTIVE'
  },
  {
    id: '02',
    name: 'INACTIVE'
  }
]
